//
// Multi - Title, subtitle
//
import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'
import css from '@styled-system/css'

import { Caption, Grid, Metadata } from 'ui/acro'

import Selected from './_modifiers/Selected'
import SelectBoxBase from './_bases/SelectBox'

const SelectBox = styled(SelectBoxBase)(
  css({
    px: '20px',
    pt: ['17px', null, '24px'],
    pb: ['15px', null, '24px'],
    alignItems: 'start',
    justifyContent: ['center', null, 'flex-start']
  })
)

const Select01 = ({ handleSelect, component, isSelected }) => {
  return (
    <Grid
      gridTemplateColumns={['1fr', null, '1fr 1fr']}
      gridColumnGap={['18px', null, '36px']}
      gridRowGap={['16px', null, '28px']}
      justifyItems='stretch'
      mb={['24px', null, '30px']}
    >
      {component.options &&
        component.options.map((option) => {
          const { majorPrompt, minorPrompt, slug } = option
          const selected = isSelected(option)
          const areaSelector = majorPrompt.replace(/\s+/g, '-').toLowerCase()
          return (
            <SelectBox
              id={`select-one-${areaSelector}`}
              key={slug}
              onClick={() => handleSelect(option)}
              selected={selected}
            >
              {majorPrompt && (
                <Caption variant='heavy' color='primary' mb='4px'>
                  {majorPrompt}
                </Caption>
              )}
              {minorPrompt && (
                <Metadata variant='normal' color='grey5'>
                  {minorPrompt}
                </Metadata>
              )}
              <Selected selected={selected} />
            </SelectBox>
          )
        })}
    </Grid>
  )
}

Select01.propTypes = {
  component: PropTypes.object.isRequired,
  handleSelect: PropTypes.func.isRequired,
  selected: PropTypes.bool
}

export default Select01
